module.exports = __webpack_public_path__ + "img/my-prize.a7c887ce.png";